// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.
//
// I secrets (CLIENT_TOKEN, ecc.) sono caricati da `./secrets.ts` (gitignored).
// Vedi `secrets.example.ts` per il template e l'istruzione di setup.

import { SECRETS } from './secrets';

export const environment = {
  production: false,
  urlServer: 'https://salvatempo.connecta.ovh/api/services',
  CLIENT_TOKEN: SECRETS.CLIENT_TOKEN,

  /** Livello di log: 'debug' | 'info' | 'warn' | 'error' | 'silent' */
  LOG_LEVEL: 'debug',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
